import styled from "styled-components";
import Column from "./Column";
const Page = styled(Column) `
  min-height: 100vh;
`;
export default Page;
